import { Eyebrow, MaskedLines, Reveal } from "../motion/Reveal";

export const PageHero = ({ eyebrow, lines, lead, image, imageAlt, children, testid = "page-hero" }) => (
  <section data-testid={testid} className="relative overflow-hidden bg-[#0C0A09] pb-20 pt-36 text-stone-100 sm:pb-28 sm:pt-44">
    <div className="tc-grid-bg absolute inset-0 opacity-50" />
    <div className="absolute -left-40 top-20 h-[460px] w-[460px] rounded-full bg-orange-600/15 blur-[140px]" />
    <div className="relative mx-auto grid max-w-[1440px] gap-12 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
      <div className={image ? "lg:col-span-7" : "lg:col-span-10"}>
        <Eyebrow>{eyebrow}</Eyebrow>
        <h1 className="mt-8 font-display text-4xl font-medium leading-[0.98] tracking-tight sm:text-6xl lg:text-7xl">
          <MaskedLines lines={lines} delay={0.1} />
        </h1>
        {lead && (
          <Reveal delay={0.35}>
            <p className="mt-8 max-w-2xl text-base leading-relaxed text-stone-300 sm:text-lg">{lead}</p>
          </Reveal>
        )}
        {children}
      </div>
      {image && (
        <Reveal delay={0.2} className="lg:col-span-5">
          <div className="relative aspect-[4/3] overflow-hidden rounded-[26px] lg:aspect-[4/5]">
            <img src={image} alt={imageAlt} className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_30%_20%,transparent_20%,rgba(12,10,9,0.75)_80%)]" />
          </div>
        </Reveal>
      )}
    </div>
  </section>
);
